import React from 'react';
import { ShieldAlert, Users, FileText, AlertTriangle, Flag, Map, Activity } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
export function RiskAnalysisPage() {
  const navItems = [{
    label: 'Verification Queue',
    icon: FileText,
    path: '/admin',
    badge: '12'
  }, {
    label: 'User Management',
    icon: Users,
    path: '/admin/users'
  }, {
    label: 'Disputes',
    icon: Flag,
    path: '/admin/disputes'
  }, {
    label: 'Risk Analysis',
    icon: AlertTriangle,
    path: '/admin/risk'
  }];
  return <DashboardLayout title="Admin Console" personaLabel="ADMIN" personaColor="bg-red-100 text-red-800 border-red-200" navItems={navItems} userInitials="AD" data-id="element-1404">
      <h1 className="text-2xl font-bold mb-8" data-id="element-1405">Risk & Fraud Detection</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1406">
        {[{
        label: 'High Risk Listings',
        value: '3',
        color: 'text-red-600'
      }, {
        label: 'Flagged Users',
        value: '12',
        color: 'text-orange-600'
      }, {
        label: 'Doc Mismatches',
        value: '8',
        color: 'text-yellow-600'
      }, {
        label: 'Suspicious IPs',
        value: '45',
        color: 'text-gray-600'
      }].map((stat, i) => <div key={i} className="bg-white border border-gray-300 p-6" data-id="element-1407">
            <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1408">
              {stat.label}
            </h3>
            <p className={`text-3xl font-bold ${stat.color}`} data-id="element-1409">{stat.value}</p>
          </div>)}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1410">
        <div className="bg-white border border-gray-300 p-6" data-id="element-1411">
          <h3 className="font-bold text-lg mb-6 flex items-center gap-2" data-id="element-1412">
            <Map className="w-5 h-5" data-id="element-1413" /> High Risk Zones
          </h3>
          <div className="h-64 border-2 border-dashed border-gray-200 bg-gray-50 flex items-center justify-center mb-4" data-id="element-1414">
            <span className="text-gray-400 font-mono" data-id="element-1415">
              [Heatmap Placeholder]
            </span>
          </div>
          <div className="space-y-2" data-id="element-1416">
            <div className="flex justify-between text-sm p-2 bg-red-50 text-red-900 border border-red-100" data-id="element-1417">
              <span data-id="element-1418">Sector 45, Gurgaon</span>
              <span className="font-bold" data-id="element-1419">Litigation Spike</span>
            </div>
            <div className="flex justify-between text-sm p-2 bg-yellow-50 text-yellow-900 border border-yellow-100" data-id="element-1420">
              <span data-id="element-1421">Whitefield Ext, Bangalore</span>
              <span className="font-bold" data-id="element-1422">Doc Forgery Reports</span>
            </div>
          </div>
        </div>

        <div className="bg-white border border-gray-300 p-6" data-id="element-1423">
          <h3 className="font-bold text-lg mb-6 flex items-center gap-2" data-id="element-1424">
            <Activity className="w-5 h-5" data-id="element-1425" /> Recent Alerts
          </h3>
          <div className="space-y-4" data-id="element-1426">
            {[{
            msg: 'Multiple listings with same 7/12 extract detected',
            time: '10 mins ago',
            level: 'Critical'
          }, {
            msg: 'User creating 50+ listings in 1 hour',
            time: '1 hour ago',
            level: 'Warning'
          }, {
            msg: 'Price deviation > 40% from market avg',
            time: '3 hours ago',
            level: 'Info'
          }].map((alert, i) => <div key={i} className="flex gap-3 items-start p-3 border-b border-gray-100 last:border-0" data-id="element-1427">
                <AlertTriangle className={`w-4 h-4 shrink-0 mt-0.5 ${alert.level === 'Critical' ? 'text-red-600' : alert.level === 'Warning' ? 'text-orange-500' : 'text-blue-500'}`} data-id="element-1428" />
                <div data-id="element-1429">
                  <p className="text-sm font-medium text-gray-800" data-id="element-1430">
                    {alert.msg}
                  </p>
                  <span className="text-xs text-gray-400" data-id="element-1431">{alert.time}</span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </DashboardLayout>;
}